import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import placeholder from '@assets/images/loading-header.png';
import { getImageMenu } from '@services/images.service';
import Image from '@components/Image';
import ErrorImage from '@components/Image/components/ErrorImage';

const SIZE = 96;

const ImageWrapper = styled.div`
  height: ${SIZE}px;
  min-width: ${SIZE}px;
  width: 100%;
  margin-left: ${({ theme, toRight }) => toRight && theme.spacing(6)};
  border-radius: 6px;
  position: relative;
  left: ${({ toRight }) => toRight && `calc(100% - 108px);`};
`;

const StyledImage = styled(Image)`
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: 6px;
`;

const getProductImage = image =>
  getImageMenu({
    image,
    width: SIZE,
    height: SIZE,
  });

function ProductImage({ image, name, toRight, ariaHidden }) {
  if (!image) return <ErrorImage />;

  return (
    <ImageWrapper toRight={toRight}>
      <StyledImage
        src={getProductImage(image)}
        placeholder={placeholder}
        alt={name}
        showErrorImage
        ariaHidden={ariaHidden}
      />
    </ImageWrapper>
  );
}

ProductImage.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string.isRequired,
  toRight: PropTypes.bool,
  ariaHidden: PropTypes.bool,
};

export default ProductImage;
